import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconSwitch = function IconSwitch(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-switch"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M2 7a1 1 0 0 1 1.01-1h15.58L16.3 3.7a1 1 0 0 1 1.42-1.4l3.99 3.99a1 1 0 0 1 0 1.41l-4 4a1 1 0 1 1-1.42-1.41l2.29-2.3H3.01A1 1 0 0 1 2 7m18.99 9H5.42l2.29-2.3a1 1 0 0 0-1.42-1.4l-4 4a1 1 0 0 0 0 1.41l4 4a1 1 0 1 0 1.4-1.42l-2.28-2.3h15.58a1 1 0 0 0 1-1 1 1 0 0 0-1-1z"
  }, pathRest)));
};
IconSwitch.displayName = 'InlineIcon(IconSwitch)';
IconSwitch.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconSwitch };
